export function unwrapOr<TError extends Error, T = unknown>(
	candidate: Error | T,
	or: TError,
): Error | TError {
	if (candidate instanceof Error) {
		return candidate;
	}

	return or as TError;
}
